import {
    BreakpointKey,
    BreakpointValues,
    HoneycombBreakpointOverrides,
    HoneycombBreakpoints,
    MediaQueries,
    MediaQueryKey,
} from '../types/HoneycombBreakpoints';

const defaultValues: BreakpointValues = {
    xs: 0,
    s: 540,
    m: 768,
    l: 1024,
    xl: 1280,
    xxl: 1348,
};

// These are in pixels
const defaultContentMargins: BreakpointValues = {
    xs: 12,
    s: 16,
    m: 20,
    l: 20,
    xl: 24,
    xxl: 24,
};

// These are in spacing units
const defaultGutters = {
    xs: 3,
    s: 3,
    m: 4,
    l: 5,
    xl: 5,
    xxl: 5,
};

export function createBreakpoints(options?: HoneycombBreakpointOverrides): HoneycombBreakpoints {
    const values = options?.values || defaultValues;
    const gutters = options?.gutters || defaultGutters;
    const contentMargins = options?.contentMargins || defaultContentMargins;
    const keys = Object.keys(values) as BreakpointKey[];

    const { xs, s, m, l, xl, xxl } = values;

    const mediaQueries: MediaQueries = {
        extraSmallUp: xs === 0 ? '' : `(min-width: ${xs}px)`,
        extraSmallOnly: `(max-width: ${s - 1}px)`,
        smallUp: `(min-width: ${s}px)`,
        smallOnly: `(min-width: ${s}px) and (max-width: ${m - 1}px)`,
        mediumUp: `(min-width: ${m}px)`,
        mediumOnly: `(min-width: ${m}px) and (max-width: ${l - 1}px)`,
        largeUp: `(min-width: ${l}px)`,
        largeOnly: `(min-width: ${l}px) and (max-width: ${xl - 1}px)`,
        extraLargeUp: `(min-width: ${xl}px)`,
        extraLargeOnly: `(min-width: ${xl}px) and (max-width: ${xxl - 1}px)`,
        extraExtraLargeUp: `(min-width: ${xxl}px)`,
    };

    return {
        keys,
        values,
        gutters,
        contentMargins,
        mediaQueries,
        mediaQueryKeys: Object.keys(mediaQueries) as MediaQueryKey[],
    };
}
